__turbopack_context__.v({
  "container": "MEioGW_container",
  "header": "MEioGW_header",
  "root": "MEioGW_root",
  "textBody": "MEioGW_textBody",
});
